import { motion, useReducedMotion } from 'framer-motion'
import { type ReactNode } from 'react'

// Opacity only, on purpose. Animating `y` puts a CSS `transform` on this
// wrapper while the animation runs, and a transformed ancestor becomes the
// containing block for every `position: fixed` descendant: any overlay,
// drawer or modal that is not portalled to <body> would then be sized and
// positioned against the page area instead of the viewport. An opacity fade
// never creates a containing block. (Keep Suspense INSIDE this wrapper, see
// AppLayout.)
const pageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
}

const reducedVariants = {
  initial: { opacity: 1 },
  animate: { opacity: 1 },
  exit: { opacity: 1 },
}

interface PageTransitionProps {
  children: ReactNode
  className?: string
}

export function PageTransition({ children, className }: PageTransitionProps) {
  const prefersReduced = useReducedMotion()

  return (
    <motion.div
      variants={prefersReduced ? reducedVariants : pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  )
}
